import template from './manage-icons.html';

export default {
  template,
  controller: 'ManageIconsController',
  bindings: {
    error: '<',
    notification: '<'
  },
};



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/manage-icons/manage-icons-component.js